import { render } from "./LanguagesTable.vue?vue&type=template&id=d6d44054&scoped=true"
import script from "./LanguagesTable.vue?vue&type=script&lang=js"
export * from "./LanguagesTable.vue?vue&type=script&lang=js"

import "./LanguagesTable.vue?vue&type=style&index=0&id=d6d44054&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6d44054"]])

export default __exports__